export default __webpack_public_path__ + "static/media/logo-dark.e82922bc.png";